import { z } from 'zod';

import { Gender } from 'common/types';
import { nonEmptyStringSchema } from 'common/zod/schemas';

const personalNameSchema = z.object({
  firstName: nonEmptyStringSchema,
  gender: z.nativeEnum(Gender),
  lastName: nonEmptyStringSchema,
});

export type PersonalNameSchema = z.infer<typeof personalNameSchema>;

export default personalNameSchema;
